import styles from './threeDotSpin.module.css';

export const ThreeDotSpin = () => {
  return (
    <div className={styles.threeBody}>
      <div className={styles.threeBody__dot}></div>
      <div className={styles.threeBody__dot}></div>
      <div className={styles.threeBody__dot}></div>
    </div>
  );
};
